export type IProductCategory = {
  ID: number;
  Name: string;
};

export type IProductTax = {
  ID: number;
  Name: string;
  Rate: number;
  AccountingCode: string;
  FiscalCode: number;
};

export type IProductSubItemProduct = {
  ID: number;
  SortOrder: number;
  IsDefault: boolean;
};

export type IMediaResource = {
  ID: number;
  Name: string;
  Location: string;
  ThumbnailLocation: string;
  ProductModifierID: number;
  ProductModifierChoiceID: number;
};

export type IModifierChoice = {
  ID: number;
  Name: string;
  ProductID: number;
  SortOrder: number;
  MaxQuantity: number;
  LocalName: string;
  KitchenCode: string;
  RemovedItemKitchenCode: string;
  RemovedItemLocalName: string;
  DefaultQuantity: number;
  PublicDescription: string;
  MediaResources: IMediaResource[];
};

export type IModifier = {
  ID: number;
  Name: string;
  Constraint: ProductModifierConstraints;
  SortOrder: number;
  Choices: IModifierChoice[];
  LocalName: string;
  KitchenCodePrefix: string;
  SelectionMode: ProductModifierSelectionMode;
  SelectionMaxChoiceCount: number;
  DisplayMode: ProductModifierDisplayMode;
};

export type IModifierSet = {
  ID: number;
  Name: string;
  Modifiers: IModifier[];
};

export type IProductAlcoholContent = {
  ID?: number;
  Name?: string;
  MinRequiredAge?: number;
};

export type IProductSalesMessageCategory = {
  ID?: number;
  Name: string;
  MinRequiredAge?: number;
  Text: string;
};

export enum ExternalIdentifier {
  FEATURED = "FEATURED",
  DISABLED = "DISABLED",
  CROSS_SELLING = "CROSS_SELLING",
}

export type IKeyword = {
  ExternalIdentifier: string;
};

export enum ProductType {
  Unknown = 0,
  Regular = 1,
  Weighted = 2,
  SeasonTicket = 3,
  Container = 4,
  Separator = 5,
  TimeBased = 6,
  Bundle = 7,
  Variable = 8,
  GiftCard = 9,
  Surcharge = 10,
}

export type IProduct = {
  ID: number;
  Column?: number;
  Name: string;
  LocalName: string;
  PublicDescription: string;
  Type: ProductType;
  Category?: IProductCategory;
  NetUnitPrice: number;
  GrossUnitPrice: number;
  IsProductEnabledForSelectedDiningOption: boolean;
  Tax: IProductTax;
  SubItemProducts: IProductSubItemProduct[];
  MediaResources: IMediaResource[];
  ModifierSet: IModifierSet;
  Keywords: IKeyword[];
  AlcoholContent?: IProductAlcoholContent;
  VariationDisplayName: string;
  SalesMessageCategory?: IProductSalesMessageCategory;
};

export type ISectionItem = {
  ID: number;
  ProductID: number;
  Column: number;
};

export type ISection = {
  ID: number;
  Name: string;
  LocalName: string;
  ProductLayoutID: number;
  RowCount: number;
  SortOrder: number;
  Items: ISectionItem[];
  MediaResources: IMediaResource[];
};

export type IProductLayoutResponse = {
  ID: number;
  Name: string;
  Products: IProduct[];
  Sections: ISection[];
  created?: number; // local usage
  userId?: number; // local usage
};

export enum ProductModifierConstraints {
  UNKNOWN = 0,
  MANDATORY = 1,
  OPTIONAL = 2,
}

export enum ProductModifierSelectionMode {
  UNKNOWN = 0,
  SINGLE_CHOICE = 1,
  MULTIPLE_CHOICE = 2,
}

export enum ProductModifierDisplayMode {
  GRAPHICAL = 1,
  TEXTUAL = 2,
}

export type GetProductLayoutsRequest = {
  productLayoutID: number;
  diningOptionId?: number;
};
